import React, { useEffect  }  from "react";
import { connect } from "react-redux";
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Input, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { requiredField } from '../../utils/crudSagaHelper';
import { doConfirmRegistration, doCancelRegistration } from "../../redux/auth/authState";
import PanelBanner from "components/banners/PanelBanner";
import { DATE_FORMAT } from '../../variables/constants';
import CrudButtons from "components/button/crudbuttons";
import RegionProvinceBarangay from "components/fields/RegionProvinceBarangay";
import CardItem from "components/card/CardItem";
import { ReactComponent as Logo } from 'assets/svg/intsamis_logo.svg';
import Button from "components/button";

const ManualRegister = ({confirmRegistration, cancelRegistration, encodedQR}) => {
  
  const [form] = useForm();
  const recordData = {};

  const handleCancelRegistration = () =>{
    cancelRegistration();
  }

  useEffect(() => {
    const initialValues = {};
      form.setFieldsValue(initialValues);
    }, [form]);

  const onSubmit = (formData) => {	
		try {  
			formData.redirect = false;
      formData.isManual = 1;
      let userName = formData.first_name + formData.last_name + formData.middle_name + formData.date_of_birth.format('YYYYMMDD');
      formData.username = userName.toLowerCase().replace(/\s/g, '');
      formData.date_of_birth = formData.date_of_birth.format('YYYY-MM-DD');
      formData.encodedQR = encodedQR?.data;
      confirmRegistration(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

  return (
    <div className="m-4 flex flex-col h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
      <PanelBanner/>

      <CardItem extra={"w-full p-4 max-w-[800px]"}
        icon={<Logo/>}
        htmlTitle={<h4 className="ml-4 card-title text-3xl dark:text-theme-200">Register User</h4>}
      >
        <Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
          layout="vertical"
          onFinish={onSubmit}
        >
          <div className="form-column-3">   
            <FormItem 
              name="last_name"
              label="Last Name"
              rules={[requiredField()]}
            >
              <Input id="last_name"
                maxLength={50}		            		
              />            
            </FormItem>        
            <FormItem 
              name="first_name"
              label="First Name"
              rules={[requiredField()]}
            >
              <Input id="first_name"
                maxLength={50}		            		
              />
            </FormItem>
            <FormItem 
              name="middle_name"
              label="Middle Name"
              rules={[requiredField()]}
            >
              <Input id="middle_name"
                maxLength={50}		            		
              />
            </FormItem>
            <FormItem 
              name="date_of_birth"
              label="Date of Birth"
              rules={[requiredField()]}
            >
              <DatePicker id="date_of_birth"
                format={DATE_FORMAT}
              />
            </FormItem>
          </div>
          <div className="form-column-3">
            <FormItem 
              name="password"
              label="Password"
              rules={[requiredField()]}
            >
              <Input id="password"
                type="password"	
                placeholder="Enter a strong password"	            		
              />
            </FormItem>
            <FormItem 
              name="password_confirmation"
              label="Confirm Password"
              rules={[requiredField()]}
            >
              <Input id="password_confirmation"
                type="password"  
                placeholder="Re-enter password"         		
              />
            </FormItem>
          </div>
          <div className="text-sm mb-4 px-2">Minimum of 8 characters with at least one uppercase, one lowercase, and a number</div>

          <CrudButtons baseRoute="/auth/home" 
            mode="edit" 
            recordId={0}
            cancelLabel="Back"
            createLabel="Register"/>
        </Form>	 	
      </CardItem>

    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
  encodedQR: state.auth.scannedQR,
});

const mapDispatchToProps = (dispatch) => ({
  confirmRegistration: (qrdata) => dispatch(doConfirmRegistration(qrdata)),
  cancelRegistration: () => dispatch(doCancelRegistration()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManualRegister);